import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import DespatchMonitoringReport from '../../common/components/DespatchMonitoringReport';
import DespatchMonitoringOverviewReportMode from '../DespatchMonitoringOverviewReportMode';
import {
  getGeneratedOnDateTime,
  getImpcModeColumns,
  getImpcModeData,
  getIsLoading,
  getOperatorModeColumns,
  getOperatorModeData,
} from '../redux/selectors/DespatchMonitoringOverviewSelectors';

const MODE_TABS = [
  { value: DespatchMonitoringOverviewReportMode.operator, label: 'Operator' },
  { value: DespatchMonitoringOverviewReportMode.impc, label: 'IMPC' },
];

export class DespatchMonitoringOverviewContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMode: DespatchMonitoringOverviewReportMode.operator,
    };
  }

  changeMode = reportMode => this.setState({ reportMode });

  renderOperatorMode() {
    return (
      <DespatchMonitoringReport
        key="operatorMode"
        reportId={ReportDefinitions.DESPATCH_MONITORING_OVERVIEW.id}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={DespatchMonitoringOverviewReportMode.operator}
        columns={this.props.operatorModeColumns}
        data={this.props.operatorModeData}
      />
    );
  }

  renderImpcMode() {
    return (
      <DespatchMonitoringReport
        key="impcMode"
        reportId={ReportDefinitions.DESPATCH_MONITORING_OVERVIEW.id}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        changeMode={this.changeMode}
        modeTabs={MODE_TABS}
        mode={DespatchMonitoringOverviewReportMode.impc}
        columns={this.props.impcModeColumns}
        data={this.props.impcModeData}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case DespatchMonitoringOverviewReportMode.operator:
        return this.renderOperatorMode();
      case DespatchMonitoringOverviewReportMode.impc:
        return this.renderImpcMode();
      default:
        return (<div>Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state, props) {
  return {
    impcModeData: getImpcModeData(state, props),
    impcModeColumns: getImpcModeColumns(state, props),
    operatorModeData: getOperatorModeData(state, props),
    operatorModeColumns: getOperatorModeColumns(state, props),
    generatedDateTime: getGeneratedOnDateTime(state, props),
    isLoading: getIsLoading(state, props),
  };
}

DespatchMonitoringOverviewContainer.propTypes = {
  impcModeData: PropTypes.arrayOf(PropTypes.object),
  operatorModeData: PropTypes.arrayOf(PropTypes.object),
  impcModeColumns: PropTypes.arrayOf(PropTypes.object),
  operatorModeColumns: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(DespatchMonitoringOverviewContainer);

